import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const ClientAuthContext = createContext(null);
const API = process.env.REACT_APP_BACKEND_URL;

export function ClientAuthProvider({ children }) {
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(() => localStorage.getItem('client_token'));

  const authHeaders = useCallback(() => {
    const t = localStorage.getItem('client_token');
    return t ? { Authorization: `Bearer ${t}` } : {};
  }, []);

  useEffect(() => {
    if (!token) { setLoading(false); return; }
    fetch(`${API}/api/client/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(d => setClient(d.client))
      .catch(() => { localStorage.removeItem('client_token'); setToken(null); })
      .finally(() => setLoading(false));
  }, [token]);

  const login = async (whatsapp, password) => {
    const res = await fetch(`${API}/api/client/login`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ whatsapp, password }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.detail || 'Login failed');
    localStorage.setItem('client_token', data.token);
    setToken(data.token);
    setClient(data.client);
    return data;
  };

  const register = async (name, whatsapp, password, currency) => {
    const res = await fetch(`${API}/api/client/register`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, whatsapp, password, currency }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.detail || 'Registration failed');
    localStorage.setItem('client_token', data.token);
    setToken(data.token);
    setClient(data.client);
    return data;
  };

  const logout = () => {
    localStorage.removeItem('client_token');
    setToken(null);
    setClient(null);
  };

  return (
    <ClientAuthContext.Provider value={{ client, loading, token, login, register, logout, authHeaders }}>
      {children}
    </ClientAuthContext.Provider>
  );
}

export const useClientAuth = () => useContext(ClientAuthContext);
